import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import { Input, Select, Button, message, Form, Space } from 'antd';
import BackButton from '../back_button/BackButton';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import {
	locationsRestCrudThunksForBuyer,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import {
	spendCategoriesRestCrudThunksForBuyer,
	spendCategoriesRestCrudThunksForSupplier,
} from '../../thunks/spend_categories_thunks';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
	problemTypesRestCrudThunksForBuyer,
	problemTypesRestCrudThunksForSupplier,
} from '../../thunks/problem_types_thunks';
import {
	workOrderAttributesRestCrudThunksForBuyer,
	workOrderAttributesRestCrudThunksForSupplier,
} from '../../thunks/work_order_attributes_thunks';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesRestCrudThunksForSupplier,
} from '../../thunks/work_order_priorities_thunks';

import {
	plannedMaintenanceTemplatesRestCrudThunksForBuyer,
	plannedMaintenanceTemplatesRestCrudThunksForSupplier,
} from '../../thunks/planned_maintenance_templates_thunks';
import { debounce } from '../../utils/PerformanceUtils';
import {
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	fetchSupplierFacilitiesInPrivateNetworkForSupplier,
	supplierFacilitiesRestCrudThunksForBuyer,
	supplierFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import { getBuyerCompanyApprovalTiers } from '../../thunks/company_approval_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import _ from 'lodash';
import { isAdminUser, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OWRichTextEditor from '../../rich_text_editor/OWRichTextEditor';
import FileUploader from '../file_uploader/FileUploader';
import ClearErrors from '../clear_errors/ClearErrors';
import { PLANNED_MAINTENANCE_TEMPLATES_CRUD_ACTION_CREATORS } from '../../actions/planned_maintenance_templates_actions';
import { useForm } from 'antd/lib/form/Form';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import OWTaskFormComponent from '../ow_inline_todo_list/OWTaskFormComponent';
import posthog from 'posthog-js';
import { OWTaskFormComponentWithAI } from '../ow_inline_todo_list/OWTaskFormComponentWithAI';
import {
	areasRestCrudThunksForBuyer,
	areasRestCrudThunksForSupplier,
	fetchAreasWithHeirarchy,
} from '../../thunks/areas_thunks';

const PLANNED_MAINTENANCE_TEMPLATE_FORM_PROBLEM_TYPES_AUTOCOMPLETE =
	'PLANNED_MAINTENANCE_TEMPLATE_FORM_PROBLEM_TYPES_AUTOCOMPLETE';
const PLANNED_MAINTENANCE_TEMPLATE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE =
	'PLANNED_MAINTENANCE_TEMPLATE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE';

const FORM_NAME = 'pm-template-form';

interface WorkOrderFormProps extends FormComponentProps {
	history: any;

	onSubmit: any;
	onCancel: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	formData: any;
	createErrors: any[];
	updateErrors: any[];
	fetchMultipleSpendCategories: any;
	fetchSpendCategories: any;
	spendCategories: any;
	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	supplierFacilities: any;
	fetchMultipleProblemTypes: any;
	fetchProblemType: any;
	fetchProblemTypes: any;
	problemTypes: any;
	fetchWorkOrderAttributes: any;
	fetchMultipleWorkOrderPriorities: any;
	fetchWorkOrderPriorities: any;
	workOrderPriorities: any;
	currentUser: any;
	update: any;
	create: any;
	fetchApprovalHeirarchy: any;
	userType: any;
	areas: any;
	fetchMultipleAreas: any;
	fetchAreas: any;
	countAreas: any;
}

const FORM_FIELD_WIDTH_STYLE = { maxWidth: 600 };

const PlannedMaintenanceTemplateForm: FC<WorkOrderFormProps> = ({
	currentUser,
	fetchApprovalHeirarchy,
	fetchWorkOrderAttributes,
	fetchProblemType,
	history,
	redirectForwardUrl,
	onSuccess,
	formData,
	update,
	create,
	fetchSupplierFacilitiesInPrivateNetwork,
	fetchMultipleSupplierFacilitiesInPrivateNetwork,
	supplierFacilities,
	problemTypes,
	workOrderPriorities,
	fetchProblemTypes,
	fetchMultipleProblemTypes,
	fetchWorkOrderPriorities,
	fetchMultipleWorkOrderPriorities,
	userType,
	areas,
	fetchMultipleAreas,
	fetchAreas,
	countAreas,
}): React.ReactElement => {
	const [nte, setNte] = useState(null);
	const [spendCategoryId, setSpendCategoryId] = useState(null);
	const [approvalHeirarchy, setApprovalHeirarchy] = useState<any>({});
	const [supplier, setSupplier] = useState(nullSafeGet('supplierFacility', formData));
	const [areaVisible, setAreaVisible] = useState(false);

	useEffect(() => {
		console.log('counting areas');
		countAreas()
			.then((count) => setAreaVisible(count > 0))
			.catch(console.log);
	}, []);

	const [loading, setLoading] = useState(false);

	const editorRef = useRef(null);

	const [form] = useForm();

	const { setFieldsValue } = form;

	const areaId = Form.useWatch('areaId', form);
	const problemTypeId = Form.useWatch('problemTypeId', form);
	const allTasks = Form.useWatch('all-tasks', form);

	useEffect(() => {
		fetchApprovalHeirarchy().then((data) => {
			const tiers = nullSafeGet('0.tierDetails', data);
			if (tiers && tiers.length > 0) {
				const userTier =
					_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) || tiers[0];
				setApprovalHeirarchy({
					amount: userTier.amountUpto || 1000000000,
				});
			}
		});
	}, [currentUser.email, fetchApprovalHeirarchy]);

	const handleNTEValueChangeDebounced = () =>
		debounce(
			(nte) => {
				setNte(nte);
			},
			500,
			false
		);

	const handleNTEValueChange = useCallback((e) => {
		const inputString = e.target.value;
		handleNTEValueChangeDebounced()(inputString);
	}, []);

	const handleProblemTypeChange = useCallback(
		(problemTypeId) => {
			if (problemTypeId) {
				fetchProblemType(problemTypeId).then((problemType) => {
					setSpendCategoryId(problemType.spendCategoryId);
					fetchWorkOrderAttributes({
						problemTypeId: problemTypeId,
					}).then((workOrderAttributes) => {
						if (workOrderAttributes.length > 0) {
							setNte(workOrderAttributes[0].NTEAmount);
						}
					});
				});
			}
		},
		[fetchProblemType, fetchWorkOrderAttributes]
	);

	const getDescription = useCallback(
		() => nullSafeGet('current', editorRef) && editorRef.current.getContent(),
		[]
	);
	const handleSupplierChange = useCallback(
		(supplierFacilityId) => {
			const supplier = nullSafeGet(`records.${supplierFacilityId}`, supplierFacilities);
			setSupplier(supplier);
		},
		[supplierFacilities]
	);

	const isAssignedToInternalSupplier = useMemo(() => {
		return nullSafeGet('status', supplier) === 'private';
	}, [supplier]);
	//Set NTE to Undefined if assigned to internal supplier
	useEffect(() => {
		if (isAssignedToInternalSupplier) setFieldsValue({ nte: undefined });
	}, [isAssignedToInternalSupplier]);

	const isUpdate = useMemo(() => formData && formData.id !== undefined, [formData]);

	const handleSubmit = useCallback(
		(values) => {
			const plannedMaintenanceTemplate = {
				...formData,
				title: values.title,
				templateId: values.templateId,
				description: getDescription(),
				workOrderPriorityId: parseInt(values.workOrderPriorityId, 10),
				nte: values.nte ? parseFloat(values.nte) : undefined,
				problemTypeId: parseInt(values.problemTypeId, 10),
				...(values.supplierFacilityId && {
					supplierFacilityId: parseInt(values.supplierFacilityId, 10),
				}),
				spendCategoryId: spendCategoryId ? parseInt(spendCategoryId, 10) : undefined,
				areaId: values.areaId ? parseInt(values.areaId, 10) : undefined,
				supplierContractId: values.supplierContractId,
				supplierContractDocuments: values.supplierContractDocuments,
				attachments: values.attachments,
				tasks: {
					taskCompletionMandatory: values.taskCompletionMandatory || false,
					tasks: allTasks,
				},
			};

			const submitAction = isUpdate ? update : create;

			setLoading(true);
			submitAction(plannedMaintenanceTemplate)
				.then((record) => {
					if (redirectForwardUrl) {
						history.push(redirectForwardUrl);
					}
					if (onSuccess) {
						onSuccess(record);
					}
				})
				.catch((err) => message.error(err))
				.finally(() => setLoading(false));
		},
		[
			allTasks,
			create,
			formData,
			getDescription,
			history,
			isUpdate,
			onSuccess,
			redirectForwardUrl,
			spendCategoryId,
			update,
		]
	);

	const handleFileManualUpload = useCallback(
		(supplierContractDocuments) => {
			setFieldsValue({ supplierContractDocuments });
		},
		[setFieldsValue]
	);

	const handleFileListChange = useCallback((info) => {
		if (info.file.status === undefined) {
			info.fileList.splice(-1, 1);
		}
		return info;
	}, []);

	const handleAttachmentsManualUpload = useCallback(
		(attachments) => {
			setFieldsValue({ attachments });
		},
		[setFieldsValue]
	);

	const handleAttachmentsListChange = useCallback((info) => {
		if (info.file.status === undefined) {
			info.fileList.splice(-1, 1);
		}
		return info;
	}, []);

	const isAdmin = useMemo(() => isAdminUser(currentUser), [currentUser]);

	const showTasksGeneratedByAI = posthog.isFeatureEnabled('open-ended-open-ai-api-enabled');

	const TasksComponent = showTasksGeneratedByAI ? OWTaskFormComponentWithAI : OWTaskFormComponent;

	return (
		<Form
			layout="vertical"
			initialValues={formData}
			onFinish={handleSubmit}
			form={form}
			id={FORM_NAME}
			className="supplierForm"
			style={FORM_FIELD_WIDTH_STYLE}
		>
			<ClearErrors actionCreators={PLANNED_MAINTENANCE_TEMPLATES_CRUD_ACTION_CREATORS} />
			<Form.Item
				label="Title"
				name="title"
				rules={[{ required: true, message: 'Please give this template a name.' }]}
			>
				<Input />
			</Form.Item>
			<Form.Item label="Template ID" name="templateId">
				<Input />
			</Form.Item>
			<Form.Item label="Description" name="description">
				<div
					style={{
						padding: '8px 16px',
						border: '1px solid #d9d9d9',
						borderRadius: 4,
						overflow: 'hidden',
						...FORM_FIELD_WIDTH_STYLE,
					}}
				>
					<OWRichTextEditor initialEditorState={formData.description} editorRef={editorRef} />
				</div>
			</Form.Item>
			{areaVisible ? (
				<Form.Item label="Area" name="areaId">
					<ProblemTypeTreeSelect
						stateSlice={areas}
						allowClear
						targetCollectionName="plannedMaintenanceTemplateAutoComplete"
						fetchMultiple={(ids, targetCollectionName) => {
							fetchMultipleAreas(ids, targetCollectionName);
						}}
						fetchData={(searchText, targetCollectionName) =>
							fetchAreas({ name: searchText }, targetCollectionName)
						}
						renderRecord={(area) => (
							<Select.Option key={area.id} value={area.id}>
								{area.name}
							</Select.Option>
						)}
					/>
				</Form.Item>
			) : null}
			<Form.Item
				label="Problem Type"
				name="problemTypeId"
				rules={[{ required: true, message: 'This field is required.' }]}
			>
				<ProblemTypeTreeSelect
					mode="default"
					placeholder="Type to search for problem type"
					stateSlice={problemTypes}
					targetCollectionName={PLANNED_MAINTENANCE_TEMPLATE_FORM_PROBLEM_TYPES_AUTOCOMPLETE}
					onChange={handleProblemTypeChange}
					fetchMultiple={(ids, targetCollectionName) => {
						fetchMultipleProblemTypes(ids, targetCollectionName);
					}}
					fetchData={(
						searchText,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
					) =>
						fetchProblemTypes(
							{ name: searchText },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						)
					}
					additionalFilters={{ areaId: areaId || undefined }}
					renderRecord={(d) => (
						<Select.Option value={d.id} key={d.id}>
							<div>{d.hierarchyName}</div>
						</Select.Option>
					)}
					sortBy={{ sort_by: 'name', order: 'ascend' }}
				/>
			</Form.Item>
			<Form.Item
				label="Priority"
				name="workOrderPriorityId"
				rules={[{ required: true, message: 'Please select a priority.' }]}
			>
				<OWAsyncSelect
					stateSlice={workOrderPriorities}
					targetCollectionName={
						PLANNED_MAINTENANCE_TEMPLATE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE
					}
					fetchMultiple={(ids, targetCollectionName) => {
						fetchMultipleWorkOrderPriorities(ids, targetCollectionName);
					}}
					fetchData={(searchText, targetCollectionName) => {
						fetchWorkOrderPriorities({ name: searchText }, targetCollectionName);
					}}
					renderRecord={(workOrderPriority) => (
						<Select.Option key={workOrderPriority.id} value={workOrderPriority.id}>
							{workOrderPriority.name}
						</Select.Option>
					)}
				/>
			</Form.Item>
			<Form.Item
				label="Not To Exceed Amount"
				name="nte"
				initialValue={formData.nte || nte}
				validateStatus={approvalHeirarchy.status}
				validateTrigger="onChange"
				help={
					approvalHeirarchy.status
						? `This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto $${approvalHeirarchy.amount}`
						: ''
				}
				rules={[
					...(!isAssignedToInternalSupplier
						? [
								{
									required: true,
									message: 'Please enter an NTE.',
								},
						  ]
						: []),
					{
						validator: (rule, value, callback) => {
							if (
								approvalHeirarchy.amount &&
								parseInt(value) > parseInt(approvalHeirarchy.amount) &&
								parseInt(value) !== formData.nte
							) {
								setApprovalHeirarchy({
									...approvalHeirarchy,
									status: isAdmin ? 'warning' : 'error',
								});
								callback(isAdmin ? undefined : '');
							} else {
								setApprovalHeirarchy({
									...approvalHeirarchy,
									status: null,
								});
								callback();
							}
						},
					},
				]}
			>
				<Input
					disabled={isAssignedToInternalSupplier}
					onChange={handleNTEValueChange}
					onClick={(e) => e.stopPropagation()}
				/>
			</Form.Item>
			<Form.Item label="Attachments" name="attachments" valuePropName="fileList">
				<div>
					<FileUploader
						roleType={userType}
						defaultFileList={formData.attachments || []}
						handleUploadSuccess={handleAttachmentsManualUpload}
						handleFileListChange={handleAttachmentsListChange}
						uploaderType={'dragger'}
					/>
				</div>
			</Form.Item>

			<Form.Item
				name="all-tasks"
				label={showTasksGeneratedByAI ? null : 'Tasks'}
				initialValue={nullSafeGetOrElse('tasks.tasks', formData, [])}
			>
				<TasksComponent PMTemplate={formData} />
			</Form.Item>

			{nullSafeGet('0', allTasks) ? (
				<Form.Item
					name="taskCompletionMandatory"
					initialValue={nullSafeGetOrElse('tasks.taskCompletionMandatory', formData, false)}
					label="Are all tasks required to be completed?"
				>
					<OWRadioGroup
						valueAccessor={(item) => item.value}
						renderRecord={(item) => item.label}
						items={[
							{
								label: 'Yes',
								value: true,
							},
							{
								label: 'No',
								value: false,
							},
						]}
					/>
				</Form.Item>
			) : null}
			<Form.Item label="Assign To" name="supplierFacilityId">
				<OWAsyncSelect
					placeholder="Rank 1 supplier will get picked based on problem type and location"
					allowClear={true}
					stateSlice={supplierFacilities}
					targetCollectionName={
						PLANNED_MAINTENANCE_TEMPLATE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE
					}
					onChange={handleSupplierChange}
					fetchMultiple={(ids, targetCollectionName) => {
						fetchMultipleSupplierFacilitiesInPrivateNetwork(ids, targetCollectionName);
					}}
					fetchData={(
						searchText,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
					) => {
						fetchSupplierFacilitiesInPrivateNetwork(
							{ name: searchText, offset: 0, limit: 100 },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						);
					}}
					renderRecord={(supplierFacility) => (
						<Select.Option key={supplierFacility.id} value={supplierFacility.id}>
							{supplierFacility.name}
						</Select.Option>
					)}
					additionalFilters={{
						problemTypeId,
					}}
					sortBy={{ sort_by: 'name', order: 'ascend' }}
				/>
			</Form.Item>
			<Form.Item label="Contract ID" name="supplierContractId">
				<Input />
			</Form.Item>
			<Form.Item
				label="Contract Documents"
				name="supplierContractDocuments"
				valuePropName="fileList"
			>
				<div>
					<FileUploader
						roleType={userType}
						defaultFileList={formData.supplierContractDocuments || []}
						handleUploadSuccess={handleFileManualUpload}
						handleFileListChange={handleFileListChange}
						accept="application/pdf"
						uploaderType={'dragger'}
					/>
				</div>
			</Form.Item>
			<Form.Item>
				<Button
					type="primary"
					htmlType="submit"
					key="submit"
					form={FORM_NAME}
					loading={loading}
					className="contactForm__button"
				>
					{`${isUpdate ? 'Update' : 'Create'} Template`}
				</Button>
				<span style={{ marginLeft: '16px' }}>
					<BackButton buttonText="Cancel" />
				</span>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,
	createErrors: state.work_orders.createErrors,
	updateErrors: state.work_orders.updateErrors,
	formData: ownProps.formData,
	spendCategories: state.spend_categories,
	problemTypes: state.problem_types,
	areas: state.areas,
	supplierFacilities: state.supplier_facilities,
	workOrderPriorities: state.work_order_priorities,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: locationsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchMultipleSpendCategories: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: spendCategoriesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchSpendCategories: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? spendCategoriesRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: spendCategoriesRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchMultipleProblemTypes: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: problemTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: problemTypesHeirarchicalForBuyer(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchProblemType: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesRestCrudThunksForSupplier.readOne(id)
				: problemTypesRestCrudThunksForBuyer.readOne(id)
		),
	fetchWorkOrderAttributes: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderAttributesRestCrudThunksForSupplier.read(params)
				: workOrderAttributesRestCrudThunksForBuyer.read(params)
		),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? fetchSupplierFacilitiesInPrivateNetworkForSupplier(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
				: fetchSupplierFacilitiesInPrivateNetworkForBuyer(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
		),
	fetchMultipleSupplierFacilitiesInPrivateNetwork: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierFacilitiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: workOrderPrioritiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchWorkOrderPriorities: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderPrioritiesRestCrudThunksForSupplier.read(
						params,
						PLANNED_MAINTENANCE_TEMPLATE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE
				  )
				: workOrderPrioritiesRestCrudThunksForBuyer.read(
						params,
						PLANNED_MAINTENANCE_TEMPLATE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE
				  )
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? areasRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: areasRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchAreas: (params, targetCollectionName) =>
		dispatch(
			fetchAreasWithHeirarchy(ownProps.userType)(
				{ ...(params || {}), isNotAssociatedToLocation: true },
				targetCollectionName
			)
		),
	countAreas: (params = {}) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? areasRestCrudThunksForSupplier.countBy(params, 'NA')
				: areasRestCrudThunksForBuyer.countBy(params, 'NA')
		),
	update: (plannedMaintenanceTemplate) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? plannedMaintenanceTemplatesRestCrudThunksForSupplier.update(plannedMaintenanceTemplate)
				: plannedMaintenanceTemplatesRestCrudThunksForBuyer.update(plannedMaintenanceTemplate)
		),
	create: (plannedMaintenanceTemplate) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? plannedMaintenanceTemplatesRestCrudThunksForSupplier.create(plannedMaintenanceTemplate)
				: plannedMaintenanceTemplatesRestCrudThunksForBuyer.create(plannedMaintenanceTemplate)
		),
	fetchApprovalHeirarchy: (id) => dispatch(getBuyerCompanyApprovalTiers(ownProps.userType, null)()),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PlannedMaintenanceTemplateForm)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
